import { Component, OnInit } from '@angular/core';

import { Marca } from "../shared/marca.model";
import { marcasModuleName } from "../shared/data.service";
import { MarcaApiService } from "../shared/marca-api.service";
import { MarcaNavigationService } from "../shared/marca-navigation.service";
import { MarcasService } from "../shared/marca.service";
import { UtilService } from "../../../shared/services/util.service";

@Component({
  template: require('./marca-list.component.html'),
  styles: [require('./marca-list.component.css')]
})
export class MarcaListComponent implements OnInit {
  list: Marca[] = [];
  loading: boolean = true;
  showDisabled: boolean = false;
  marcasModuleName: any = marcasModuleName;

  constructor(
    private _marcasApiService: MarcaApiService,
    private _marcasService: MarcasService,
    private _marcaNavigationService: MarcaNavigationService,
    private _utilService: UtilService
  ) { }

  ngOnInit() {
    this.getAll();
  }

  clickNew() {
    this._marcasService.clearSessionStorage();
    this._marcaNavigationService.goToNew();
  }

  clickEdit(item: Marca) {
    this._marcasService.clearSessionStorage();
    this._marcaNavigationService.goToEdit(item.id);
  }

  clickDelete(item: Marca) {
    var onDelete = (function() {
      this.onDelete(item);
    }.bind(this));

    this._utilService.swalMessageDelete(onDelete);
  }

  private getAll() {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        this.list = Response;
      }
      this.loading = false;
    }.bind(this));

    this._marcasApiService.onGetAll(onDone);
  }

  private onDelete(item: any) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        var x: number, lenX: number;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
          if (this.list[x].id === item.id) {
            this.list[x].ativo = false;
            break;
          }
        }
        this._utilService.swalMessageDeleteSuccess();
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._marcasApiService.onDelete(item.id, onDone);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/marcas/marca-list/marca-list.component.ts
 **/